import Button from 'components/atoms/button/Button'
import IconButton from 'components/atoms/button/IconButton'
import Checkbox from 'components/atoms/checkbox/Checkbox'
import Icon from 'components/atoms/icon/Icon'
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import TabsSwitch from 'components/molecules/tabs/TabsSwitch'
import { IconType } from 'lib/helpers/constants/iconTypes'
import { useSubmitPaperApplication } from 'lib/hooks/mutations/Customers/useSubmitPaperApplication'
import { useCustomerPendings } from 'lib/hooks/queries/Coustomer/useCustomerPendings'
import React, { FC, useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'


interface Props {
    id: number;
    setDocumentData: (data: any) => void;
    setCurrentStep: (step: number) => void;
    setCheckedDocuments: (data: any) => void;
    CheckedDocuments?: any;
    onConfirm: () => void;
}

const SubmitFiles: FC<Props> = ({ id, setDocumentData, setCurrentStep, setCheckedDocuments, CheckedDocuments,onConfirm }) => {

    const { t } = useTranslation()

    const { data, isLoading } = useCustomerPendings(id)

    const [activeTabs, setActiveTabs] = useState();

    const groupedByCompany = useMemo(() => {
        if (!data) return

        const groupedUsers = data.reduce((acc: any, item: any) => {
            if (!acc[item.company]) {
                acc[item.company] = [];
            }
            acc[item.company].push(item);
            return acc;
        }, {});

        setActiveTabs(() => {
            const initialTabs: any = [];

            Object.entries(groupedUsers).forEach(([company, products]: [any, any]) => {
                initialTabs[company] = products[0]?.product; // default to the first product
            });

            return initialTabs;
        })

        return groupedUsers
    }, [data])


    const handleTabChange = (company: any, newTabId: any) => {
        setActiveTabs((prev: any) => ({
            ...prev,
            [company]: newTabId,
        }));
    };

    const getSingleProduct = useCallback((company: any, products: any) => {

        return products.find(
            (product: any) =>
                product.product ===
                (activeTabs ? activeTabs[company] : products[0]?.product))

    }, [activeTabs])

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, doc: any, company: string) => {
        if (e.target.checked) {
            setCheckedDocuments((prev: any) => {
                const existingCompany = prev.find((item: any) => item.company === company);
                if (existingCompany) {
                    return prev.map((item: any) =>
                        item.company === company
                            ? { ...item, files: [...item.files, doc] }
                            : item
                    );
                } else {
                    return [...prev, { company, files: [doc] }];
                }
            });
        } else {
            setCheckedDocuments((prev: any) => {
                return prev
                    .map((item: any) =>
                        item.company === company
                            ? { ...item, files: item.files.filter((file: any) => file !== doc) }
                            : item
                    )
                    .filter((item: any) => item.files.length > 0);
            });
        }
    }


    const { mutateAsync, isLoading: SubmitLoading } = useSubmitPaperApplication()

    const SubmitFiles = () => {


        const formmatedCheckedDocuments = CheckedDocuments.map((item: any) => {
            return {
                company: item.company,
                files: item.files.map((file: any) => file.file)
            }
        })

        const finalData = {
            costumer_id: id,
            files_to_send: formmatedCheckedDocuments
        }

        mutateAsync(finalData).then(() => {
            onConfirm()

        })
    }


    if (isLoading) return (
        <LoadingScreen />
    )

    if(!data || data.length === 0) return ( 
        <div className='flex items-center justify-center h-[200px] w-full max-w-[400px] mx-auto text-center'>
            <p className='text-primaryTextColor font-inter-regular text-base'>{t("No documents found. The required documents for this customer have not been uploaded yet or are still pending approval")}</p>
        </div>
    )

    return (
        <div className='space-y-10 pt-5'>
            <div className='bg-[#F6FBFE] rounded-[20px] p-4'>
            
                {Object.entries(groupedByCompany).map(([company, products]: [string, any]) => (
                    <div className={"mb-[30px]"} key={company}>

                        <div className="pb-1">
                            <p className="font-inter-regular text-primaryTextColor text-base">
                                {company}
                            </p>
                        </div>
                        <TabsSwitch
                            ActiveTab={activeTabs ? activeTabs[company] : products[0]?.product}
                            setSelectedTab={(tabId) => handleTabChange(company, tabId)}
                            classes={{
                                unActiveTabClass: '!px-0 !py-2 sm:!me-7',
                                activeTabClass: '!font-inter-semibold',
                                container: 'border-b',
                            }}
                            tabs={products.map((product: any) => {
                                return {
                                    id: product?.product,
                                    name: product?.product,
                                };
                            })}
                        />
                        <div className="flex flex-wrap lg:flex-row	items-center gap-[12px]">
                            {getSingleProduct(company, products)?.documents?.map((doc: any, docIndex: number) => {
                                if (doc.file === '') return null

                                return (
                                    <div
                                        key={docIndex}
                                        role="button"
                                        className="w-[120px] flex flex-col items-center justify-center h-[120px] relative border-[1px] border-[#D0D5DD] border-dashed rounded-[10px] bg-white">
                                        <div className="flex items-center absolute top-0 pl-2 pt-1 pr-2 justify-between w-full">
                                            <Checkbox
                                                classes={{
                                                    container: '!h-[18px] !w-[18px]',
                                                    checkboxContainer: '!h-[18px] !w-[18px] !-translate-x-[53%]',
                                                }}
                                                checked={CheckedDocuments?.find((item: any) => item.company === company)?.files?.find((file: any) => file.file === doc.file) !== undefined}
                                                onChange={(e) => { handleCheckboxChange(e, doc, company) }}
                                            />
                                            <Button
                                                type="button"
                                                onClick={() => {
                                                    setCurrentStep(10);
                                                    setDocumentData(doc.file);
                                                }} >
                                                <Icon
                                                    iconType={IconType.SHOW_PASSWORD_ICON}
                                                    className="w-[18px]"
                                                />
                                            </Button>
                                        </div>
                                        <div>
                                            <Icon
                                                iconType={IconType.PDFUPLOAD_ICON}
                                            />
                                        </div>
                                        <div className="mt-[10px] text-[14px] font-inter-regular capitalize text-center">
                                            {t(doc?.name)}
                                        </div>
                                    </div>
                                );
                            })
                            }
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex justify-end gap-4">
                <IconButton secondary className='w-full sm:max-w-[175px]' onClick={() => { setCurrentStep(1) }} disabled={SubmitLoading}>
                    {t('Cancel')}
                </IconButton>
                <IconButton className='w-full sm:max-w-[175px]' onClick={SubmitFiles} disabled={CheckedDocuments?.length === 0 || SubmitLoading}>
                    {t('Submit')}
                </IconButton>
            </div>
        </div>
    )
}

export default SubmitFiles